import type { PickemQuestion } from '@bet99-pickem/api-types';
import type { TeamPair } from '@/types/domain';
import { getOptionId } from './id-helpers';
import { findOptionByTitle } from './id-helpers';
import { getLocalizedField } from './localized-field';
import i18n from '@/i18n';

// Re-export TeamPair for backwards compatibility
export type { TeamPair };

const COLORS = [
  { color: '#c8102e', accent: '#000000' },
  { color: '#003f7f', accent: '#ffffff' },
  { color: '#006847', accent: '#ffffff' },
  { color: '#fcb514', accent: '#000000' },
];

function createMockTeam(option: PickemQuestion['options'][0] | undefined, index: number): TeamPair {
  const colorPair = COLORS[index % COLORS.length];
  const locale = i18n.language;

  return {
    id: option ? getOptionId(option) : `team${index + 1}`,
    name: option ? getLocalizedField(option, 'title', locale) : `Team ${index + 1}`,
    color: colorPair.color,
    accent: colorPair.accent,
    jerseyUrl: option?.option_image,
  };
}

export function getTeamsForQuestion(question: PickemQuestion): TeamPair[] {
  return question.options.map((option, index) => {
    return createMockTeam(option, index);
  });
}

export function getPercentagesForPropQuestion(question: PickemQuestion) {
  const yesOption = question.options.find(opt => opt.title_en?.toLowerCase().includes('yes'));
  const noOption = question.options.find(opt => opt.title_en?.toLowerCase().includes('no'));

  return {
    yes: yesOption?.popularity_pct || 50,
    no: noOption?.popularity_pct || 50,
  };
}

export function findOptionByAnswer(
  question: PickemQuestion,
  answer: 'yes' | 'no'
): string | undefined {
  // First try to find by title containing yes/no
  let option = findOptionByTitle(question, answer);

  // If not found, map by position: first option = yes, second = no
  if (!option && question.options.length >= 2) {
    option = answer === 'yes' ? question.options[0] : question.options[1];
  }

  return option ? getOptionId(option) : undefined;
}
